"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var get_resized_image_url_1 = tslib_1.__importStar(require("../../../common/utils/get-resized-image-url"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var normalize_image_dimensions_1 = require("../../../common/utils/normalize-image-dimensions");
var responsive_resized_image_scss_1 = tslib_1.__importDefault(require("./responsive-resized-image.scss"));
var withStyles_1 = require("../../utils/withStyles");
var ResponsiveResizedImage = /** @class */ (function (_super) {
    tslib_1.__extends(ResponsiveResizedImage, _super);
    function ResponsiveResizedImage(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = react_1.default.createRef();
        _this.state = {
            resizedThumbnailUrl: _this.getResizedImageUrl(props),
        };
        return _this;
    }
    ResponsiveResizedImage.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.props.progressive) {
            return;
        }
        var resizedThumbnailUrl = this.getResizedImageUrl(this.props);
        this.setState({ resizedThumbnailUrl: resizedThumbnailUrl }, function () {
            var image = new Image();
            image.src = resizedThumbnailUrl;
            image.onload = function () {
                if (!_this.ref.current) {
                    return;
                }
                _this.ref.current.style.backgroundImage = "url(" + resizedThumbnailUrl + ")";
            };
        });
    };
    ResponsiveResizedImage.prototype.getResizedImageUrl = function (_a) {
        var _b = _a === void 0 ? this.props : _a, src = _b.src, _c = _b.width, width = _c === void 0 ? 320 : _c, _d = _b.height, height = _d === void 0 ? 180 : _d, params = _b.params, backgroundFit = _b.backgroundFit;
        var dimensions = normalize_image_dimensions_1.getNormalizedCachedDimensions(src, {
            containerWidth: width,
            containerHeight: height,
        });
        var mode = backgroundFit ? get_resized_image_url_1.MODES.fit : undefined;
        return get_resized_image_url_1.default({
            url: src,
            width: dimensions[0],
            height: dimensions[1],
            params: params,
            mode: mode,
        });
    };
    ResponsiveResizedImage.prototype.render = function () {
        var _a, _b;
        var _c = this.props, className = _c.className, children = _c.children, dataHook = _c.dataHook, animated = _c.animated, withFallbackColor = _c.withFallbackColor, backgroundFit = _c.backgroundFit, isMobile = _c.isMobile, nonProportional = _c.nonProportional;
        var resizedThumbnailUrl = this.state.resizedThumbnailUrl;
        var classNames = classnames_1.default(className, responsive_resized_image_scss_1.default['resized-image'], (_a = {},
            _a[responsive_resized_image_scss_1.default['with-fallback-color']] = withFallbackColor && !resizedThumbnailUrl,
            _a[responsive_resized_image_scss_1.default['background-contain']] = backgroundFit,
            _a[responsive_resized_image_scss_1.default.mobile] = isMobile,
            _a[responsive_resized_image_scss_1.default['with-transitions']] = animated,
            _a));
        return (react_1.default.createElement("div", { className: classnames_1.default(responsive_resized_image_scss_1.default.container, (_b = {},
                _b[responsive_resized_image_scss_1.default['non-proportional']] = nonProportional,
                _b)) },
            react_1.default.createElement("div", { ref: this.ref, className: classNames, style: {
                    backgroundImage: "url(" + resizedThumbnailUrl + ")",
                }, "data-hook": dataHook, role: "presentation" }, children)));
    };
    ResponsiveResizedImage.propTypes = {
        src: prop_types_1.default.string.isRequired,
        width: prop_types_1.default.number,
        height: prop_types_1.default.number,
        params: prop_types_1.default.object,
        style: prop_types_1.default.object,
        className: prop_types_1.default.string,
        children: prop_types_1.default.node,
        dataHook: prop_types_1.default.string,
        withFallbackColor: prop_types_1.default.bool,
        backgroundFit: prop_types_1.default.bool,
        isMobile: prop_types_1.default.bool,
        progressive: prop_types_1.default.bool,
        animated: prop_types_1.default.bool,
        nonProportional: prop_types_1.default.bool,
    };
    ResponsiveResizedImage.defaultProps = {
        params: {},
        style: {},
    };
    ResponsiveResizedImage = tslib_1.__decorate([
        withStyles_1.withStyles(responsive_resized_image_scss_1.default)
    ], ResponsiveResizedImage);
    return ResponsiveResizedImage;
}(react_1.default.Component));
exports.ResponsiveResizedImage = ResponsiveResizedImage;
//# sourceMappingURL=responsive-resized-image.js.map